import { useSelector } from "react-redux";

export const useClientSelector = () => ({
  anonymityInfo: useSelector((state) => state.client.anonimityInfo),
  client: useSelector((state) => state.client.client),
  blackList: useSelector((state) => state.client.blacklist),
  anonymityScore: useSelector((state) => state.client.anonimityScore),
  openPorts: useSelector((state) => state.client.openPorts)
});
